(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["user-auth-hover-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    function detectDeviceType() {
      var ua = navigator.userAgent || '';
      var uaLower = ua.toLowerCase();

      if (uaLower.includes('iphone') || uaLower.includes('android') || uaLower.includes('mobile')) {
        return 'mobile';
      }

      // Fallback based on viewport
      if (window.innerWidth <= 768) {
        return 'mobile';
      }

      return 'desktop';
    }

    var deviceType = detectDeviceType();

    document.documentElement.setAttribute('data-device-type', deviceType);
    console.log('Detected device type:', deviceType);
  })();
  } catch(e) { console.error(e); }
})();

})();
